import { createInertiaApp } from "@inertiajs/vue3"
import ui from "@nuxt/ui/vue-plugin"
import type { DefineComponent } from "vue"
import { createApp, h } from "vue"

import DefaultLayout from "@/layouts/DefaultLayout.vue"
import { trackViewportHeight } from "@/lib/viewportHeight"

const appName = "Ninjanizr"

// Publish a reliable --app-height (WebView reports 0 for vh units).
trackViewportHeight()

createInertiaApp({
  title: (title) => (title ? `${title} — ${appName}` : appName),

  resolve: (name) => {
    const pages = import.meta.glob<DefineComponent>("../pages/**/*.vue", {
      eager: true,
    })
    const page = pages[`../pages/${name}.vue`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.vue'`)
    }

    page.default.layout ??= DefaultLayout

    return page
  },

  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ui)
      .mount(el)
  },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
  },

  progress: {
    color: "#4B5563",
  },
}).catch((error) => {
  if (document.getElementById("app")) {
    throw error
  }
})

// PWA: register service worker and suppress install nag
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js")
}
window.addEventListener("beforeinstallprompt", (e) => e.preventDefault())
